
import { Component, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import { getStickerPath, getStickerCoverPath, getStickerPattern } from '@xt/client/utils/sticker'

@Observer
@Component({
  components: {}
})
export default class StickerInput extends Vue {
  current: number = 0

  stickerConfig = [
    {
      name: 'group-1',
      sticker: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16']
    },
    {
      name: 'group-2',
      sticker: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16']
    }
  ]

  get name() {
    return this.stickerConfig[this.current].name
  }

  get sticker() {
    return this.stickerConfig[this.current].sticker
  }

  getStickerImage(groupName: string, stickerName: string) {
    return getStickerPath(groupName, stickerName)
  }

  getStickerCover(groupName: string) {
    return getStickerCoverPath(groupName)
  }

  handleClickStickerItem(groupName: string, stickerName: string) {
    this.$emit('click', getStickerPattern(groupName, stickerName))
  }

  handleClickStickerGroup(groupName: string) {
    const index = this.stickerConfig.findIndex(i => i.name === groupName)

    if (index !== -1) {
      this.current = index
    }
  }

  noop() {}

  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
